import * as angular from 'angular';
import { ILogbookService } from '../../services/';
import { ComponentDefinition } from '../../models';

class CategoriesSelectController implements angular.IComponentController {
    categories: string[];
    model: string[];
    
    readonly isDisabled: boolean;
    readonly propertyName: string;

    static $inject = ['logbookService'];
    constructor(private _logbookService: ILogbookService) {
    }

    $onInit() {
        if (!this.model) {
            this.model = [];
        }

        this._logbookService.getAllLabels()
            .then(data => {
                this.categories = data.map(d => d.name);
            });
    }
}

export const wtCategoriesSelect: ComponentDefinition = {
    componentId: 'wtCategoriesSelect',
    controller: CategoriesSelectController,
    template: require('./categoriesSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        propertyName: '<',
        isDisabled: '<'
    }
};
